export type REQUIRED = (value: string) => string | undefined

export const mustBeRequired: REQUIRED = value =>
  value ? undefined : 'REQUIRED'
